import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import CustomerTabs from "./customerTabs";
import CustomerDataEntryPopup from "../../../../../id/codes/customerDataEntry/common/CustomerDataEntryPopup";
import { Button } from 'devextreme-react/button';
import SalesOrderOptionsButton, { OptionsTabType } from "../common/SalesOrderOptionsButton";

const CustomerResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const [currentLayout, setCurrentLayout]= useState("Default");
    const gridKey = "6bd793d2-4a00-47e7-83ad-4b85710134d0";
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const childRef = useRef();
    const [showPopup, setShowPopup] = useState({id:null,visible:false});
    const [selectedCustomerId, setSelectedCustomerId] = useState(null);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
          }
          setSelectedCustomerId(selectedRowData?.rowid ?? null);
          setShowPopup({id:selectedRowData.rowid,visible:false});
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single"  />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="recordNumber" caption='Record#' ></Column>
                <Column dataField="identityid" caption='Customer' ></Column>
                <Column dataField="name" caption='Name' ></Column>
                <Column dataField="address1" caption='Address -1' ></Column>
                <Column dataField="address2" caption='Address -2' ></Column>
                <Column dataField="city" caption='City' ></Column>
                <Column dataField="state" caption='State' ></Column>
                <Column dataField="zip" caption='Zip' ></Column>
                <Column dataField="country" caption='Country' ></Column>
                <Column dataField="telephone1" caption='Telephone1' ></Column>
                 <Toolbar>
                <Item location="before">
                    <Button text="Edit" disabled={!showPopup.id} type="default" onClick={()=>setShowPopup(prevFormData=>({...prevFormData, visible:true}))} />
                </Item>
                <Item location="before">
                    <SalesOrderOptionsButton tabType={OptionsTabType.Customer} customerId={selectedCustomerId} />
                </Item>
                 <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <CustomerTabs ref={childRef} accessToken={accessToken} />
            <CustomerDataEntryPopup showPopup={showPopup} setShowPopup={setShowPopup}/>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CustomerResult);